import { useQuery } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { getProductDetails } from '../api'
import { keys as dataSourceKeys } from '../queryKeys'

type Props = {
  accountId: string | undefined
  catalogId: string | undefined
  categoryId: string | undefined
  productId: string | undefined
  region: string | undefined
}

const useGetProductDetailsQuery = ({
  accountId,
  catalogId,
  categoryId,
  productId,
  region,
}: Props) => {
  return useQuery(
    dataSourceKeys.productDetails({
      accountId,
      catalogId,
      categoryId,
      productId,
      region,
    }),
    () => {
      if (!accountId || !catalogId || !categoryId || !productId || !region) {
        return undefined
      }
      return getProductDetails({
        accountId,
        catalogId,
        categoryId,
        productId,
        region,
      })
    },
    {
      enabled:
        !!accountId && !!catalogId && !!categoryId && !!productId && !!region,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      onError: () => {
        errorToast('Failed to fetch product details')
      },
    }
  )
}

export default useGetProductDetailsQuery
